import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Helmet } from "react-helmet-async";

import { NewTabLink } from "src/components/NewTabLink";
import PageTemplate from "src/pages/PageTemplate";

import HowItWorksContent from "./components/HowItWorksContent";

const HowItWorksPage = () => {
  return (
    <>
      <Helmet link={[{ rel: "canonical", href: "/how-it-works/" }]}>
        <title>How It Works | Pre-Reg Shortcuts</title>
        <meta
          name="description"
          content="Discover how easy it is to enrol on our foundation training year program for Trainee Pharmacists."
        />
        <meta
          name="keywords"
          content="How Pre-Reg Shortcuts Works, Steps to access foundation year programme, Online training platform, Easy enrolment, Enrol now"
        />
      </Helmet>
      <PageTemplate title="How Pre-Reg Shortcuts Works">
        <HowItWorksContent />

        <Divider sx={{ mt: { xs: 9, md: 8 } }} style={{ borderColor: "transparent" }} />

        <Stack spacing={3} sx={{ alignItems: "center", pb: { xs: 8 }, mt: 1, mb: 2 }}>
          <Typography variant="h2" sx={{ textAlign: "center" }}>
            Not Sure What You're Looking For?
          </Typography>
          <Typography variant="body1">
            The quickest way to find answers is by visiting our <NewTabLink href="/faq/">FAQ's</NewTabLink> or messaging
            the Live Chat team.
          </Typography>
          <Typography variant="body1">
            For a 1:1 chat, fill out our quick contact form and we'll be in touch.
          </Typography>

          <Button
            variant="outlined"
            color="inherit"
            href="https://preregshortcuts.fillout.com/booking"
            style={{ width: "130px" }}
            target="_blank"
          >
            Complete Now
          </Button>
        </Stack>
      </PageTemplate>
    </>
  );
};

export default HowItWorksPage;
